import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-html-renderer',
    templateUrl: './html-renderer.component.html',
    styleUrls: ['./html-renderer.component.scss']
})
export class HtmlRendererComponent {
    @Input() public html: string;
}
